import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import buttonStyles from "../../../../styles/Button.module.css";
//import menuStyle from "../../../../styles/Menu.module.css";
import "./productosPaquetesTable.css";
import "./../htmlTable.css";

import * as api from "helper/helper";
import CreateProductoPaquete from "./CreateProductoPaquete";
import SearchBar from "../SearchBar";

import { HasSubSectionPermission, PermissionsForSection } from "../auth";

import navList, { Sections, SubSections } from "../../data/navItem";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import { handleStatus } from "../../helperFunctions/helpers";
import ExportCSV from "../ExportCSV";
import TableOptionCheck from "../Productos/TableOptionCheck";
import PaquetesProductosTable from "./PaquetesProductosTable";
import { useAuthStore } from "../../../../store/store";
/*
function SectionOption(id = "", title = "", isSelected = false) {
  this.id = id;
  this.title = title;
  this.isSelected = isSelected;
}*/

function ProductosPaquetesCatalogo({ subSectionId }) {
  const isAdmin = useAuthStore((state) => state.isAdmin);

  const Menus = {
    Marca: 0,
    Tags: 1,
    Status: 2,
    Genero: 3,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const FilterValues = {
    PAQUETE: 1,
    PRODUCTO: 2,
  };

  const [filterOptions] = useState(
    {
      id: FilterValues.PAQUETE,
      name: "Paquete",
    },
    {
      id: FilterValues.PRODUCTO,
      name: "Producto",
    },
  );

  const createPaqueteRef = useRef();
  const filtrosRef = useRef([]);
  const csvRef = useRef();

  const filterSelectRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [paquetes, setPaquetes] = useState([]);
  const [tags, setTags] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [generos, setGeneros] = useState([]);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: isAdmin,
  });

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros, setFiltros] = useState([
    { type: Menus.Marca, name: "Marca" },
    { type: Menus.Genero, name: "Genero" },
    { type: Menus.Tags, name: "Etiquetado con" },
    {
      type: Menus.Status,
      name: "Estatus",
    },
    /* { type: "add_filter", name: "Agregar filtro" },*/
  ]);

  const [canCreateNewPackage, setCanCreateNewPackage] = useState(false);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async (resetPageNumber = true) => {
    let criteria = searchCriteria;
    if (resetPageNumber) {
      /// reset pag info
      pagingInfoRef.current.resetPageInfo();
    }

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  const fetchTags = async () => {
    /*const responseTags = await api.tags().catch((error) => {
      toast.error("Error al pedir tags.");
      setIsLoading(false);
    });
    if (!responseTags) return;

    setTags(responseTags.data);*/
  };

  /*const fetchCatalogos = async () => {
    setIsLoading(true);
    const responseMarcas = await api.marcas().catch((error) => {
      toast.error("Error al pedir marcas.");
      setIsLoading(false);
    });
    if (!responseMarcas) return;

    setMarcas(responseMarcas.data);

    const responseGeneros = await api.generos().catch((error) => {
      toast.error("Error al pedir generos.");
      setIsLoading(false);
    });
    if (!responseGeneros) return;

    setGeneros(responseGeneros.data);

    fetchTags();
    setFiltros([...filtros]);

    setIsLoading(false);
  };*/

  useEffect(() => {
    fetchData();
    //  fetchCatalogos();

    //   _id: Sections.Configuraciones,
    const configuracionSection = navList.find(
      (e) => e._id === Sections.Configuraciones,
    );
    if (configuracionSection == null) {
      return;
    }

    const paquetesSection = configuracionSection.subs.find(
      (e) => e._id === SubSections.Paquetes,
    );

    if (paquetesSection == null) {
      return;
    }

    const canCreate = HasSubSectionPermission(
      Sections.Configuraciones,
      paquetesSection.remoteid,
      ["crear"],
    );

    const newPermissions = PermissionsForSection(Sections.Productos);
    setPermissions(newPermissions);

    // edit only admin
    newPermissions.canVerDetalle = isAdmin;

    setCanCreateNewPackage(canCreate);
  }, []);

  useEffect(() => {
    if (modalData == null) return;

    createPaqueteRef.current.toggleModal();
  }, [modalData]);

  function createPaquete(event) {
    console.log(event);
    loadItem({});
  }

  function reloadPaquetes() {
    fetchTags();
    fetchData(false);
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    setModalData(null);

    setTimeout(() => {
      setModalData(item);
    }, 100);
  }

  /**
   * Search handler
   */
  const clearTagsFilter = () => {
    tags.forEach((item) => {
      item.checked = false;
    });

    setTags(tags.slice());

    updateTagsCriteria([]);

    filtrosRef.current[Menus.Tags].hideMenu();
  };

  const handleTagsChange = (event, item, options) => {
    item.checked = !item.checked;

    let criteria = searchCriteria;
    let tagIds = criteria["TagIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !tagIds.includes(item.id)) {
      tagIds.push(itemId);
    } else if (!event.currentTarget.checked && tagIds.includes(item.id)) {
      tagIds = tagIds.filter((f) => f !== itemId);
    }

    updateTagsCriteria(tagIds);
  };

  const updateTagsCriteria = (tagIds) => {
    let criteria = searchCriteria;

    criteria["TagIds"] = tagIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Tags;
    });

    if (index === -1) {
      return;
    }
    var tagsNames = "";
    if (tagIds.length > 0) {
      //
      const tagsFilter = tags.filter((currItem) => {
        return tagIds.includes(currItem.id);
      });

      tagsNames = tagsFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(tagsNames);
  };

  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    criteria["texto"] = e;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Marca && item.type === Menus.Marca) {
        clearMarcasFilter();
      } else if (value.type === Menus.Tags && item.type === Menus.Tags) {
        clearTagsFilter();
      } else if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      } else if (value.type === Menus.Genero && item.type === Menus.Genero) {
        clearGenerosFilter();
      }
    });
  }

  const clearMarcasFilter = () => {
    marcas.forEach((item) => {
      item.checked = false;
    });

    setMarcas(marcas.slice());

    updateMarcasCriteria([]);

    filtrosRef.current[Menus.Marca].hideMenu();
  };

  const handleMarcaClick = (event, item, options) => {
    item.checked = !item.checked;

    let criteria = searchCriteria;
    let nivelIds = criteria["marcaIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateMarcasCriteria(nivelIds);
  };

  const updateMarcasCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["marcaIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Marca;
    });

    if (index === -1) {
      return;
    }
    var marcasNames = "";
    if (nivelIds.length > 0) {
      //
      const marcasFilter = marcas.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      marcasNames = marcasFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(marcasNames);
  };

  const handleGeneroClick = (event, item, options) => {
    item.checked = !item.checked;

    let criteria = searchCriteria;
    let generoIds = criteria["GeneroIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !generoIds.includes(item.id)) {
      generoIds.push(itemId);
    } else if (!event.currentTarget.checked && generoIds.includes(item.id)) {
      generoIds = generoIds.filter((f) => f !== itemId);
    }

    updateGenerosCriteria(generoIds);
  };

  const updateGenerosCriteria = (generoIds) => {
    let criteria = searchCriteria;

    criteria["GeneroIds"] = generoIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Genero;
    });

    if (index === -1) {
      return;
    }
    var generoNames = "";
    const found = generos.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    generoNames = found.join(", ");

    /*  if (generoIds.length > 0) {
      //
      const marcasFilter = generos.filter((currItem) => {
        return generoIds.includes(currItem.id);
      });

      generoNames = marcasFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }
*/
    filtrosRef.current[index].toka(generoNames);
  };

  const clearGenerosFilter = () => {
    generos.forEach((item) => {
      item.checked = false;
    });

    setGeneros(generos.slice());

    updateGenerosCriteria(undefined);

    filtrosRef.current[Menus.Genero].hideMenu();
  };

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);

    let response = null;
    if (filterSelectRef.current.value == FilterValues.PAQUETE) {
      criteria["Nombre"] = criteria["texto"];
      criteria["NombreProducto"] = "";
      response = await api.searchPaquetes(criteria).catch((error) => {
        toast.error("Error al buscar Paquetes.");
        setIsLoading(false);
      });
    } else if (filterSelectRef.current.value == FilterValues.PRODUCTO) {
      criteria["NombreProducto"] = criteria["texto"];
      criteria["Nombre"] = "";
      response = await api.searchPaquetes(criteria).catch((error) => {
        toast.error("Error al buscar Paquetes.");
        setIsLoading(false);
      });
    }
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    setPaquetes(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados

    const csvString = [
      ["Id", "Nombre", "Marca", "Genero", "Tamaño", "Concentración", "Estatus"], // Specify your headers here
      ...paquetes.map((item) => {
        const id = item.numProducto ?? "";

        return [
          id,
          item.nombre ?? "",
          item.marca?.nombre ?? "",
          item.genero?.nombre ?? "",
          item.tamaño?.nombre ?? "",
          item.concentracion?.nombre ?? "",
          handleStatus(item).text,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "productosCatalogo.csv");
  }

  return (
    <>
      <ExportCSV ref={csvRef} />

      <div className="card recent-sales overflow-auto">
        <div className="separator"></div>
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div
              className="header"
              style={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              Buscar por:
              <select
                ref={filterSelectRef}
                className="form-select"
                aria-label="Default select example"
                style={{ width: "200px" }}
                onChange={(e) => {
                  let criteria = searchCriteria;
                  onChangeSearchText(criteria["texto"]);
                }}
              >
                <option disabled>Selecciona filtro</option>
                <option value="1" selected>
                  Paquete
                </option>
                <option value="2">Producto</option>
              </select>
              <SearchBar
                onChange={(e) => onChangeSearchText(e)}
                placeholder="Nombre..."
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "30px",
                gap: "10px",
              }}
            >
              {/*    <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginLeft: "0px" }}
                disabled={isLoading}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>*/}
              <button
                className="btn btn-primary"
                onClick={createPaquete}
                hidden={!canCreateNewPackage}
              >
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Paquete
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{
                display: "flex",
                columnGap: "6px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            ></div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item) => {
              let page = pagingInfoRef.current.page;
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>

        <div className="card-body">
          <PaquetesProductosTable
            items={paquetes}
            openItem={loadItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
          />
        </div>

        <CreateProductoPaquete
          ref={createPaqueteRef}
          item={modalData}
          reloadProducto={reloadPaquetes}
        />
      </div>
    </>
  );
}

export default React.memo(ProductosPaquetesCatalogo);
